export const TRAVEL_EXPENSE_CATEGORIES = [
  'flight',
  'train',
  'hotel',
  'transfer',
  'car_rental',
  'meals',
  'parking',
  'fuel',
  'tolls',
  'business',
  'other',
] as const;

export type TravelExpenseCategory = typeof TRAVEL_EXPENSE_CATEGORIES[number];

export const TRAVEL_EXPENSE_CATEGORY_LABELS: Record<TravelExpenseCategory, string> = {
  flight: 'Volo',
  train: 'Treno',
  hotel: 'Albergo',
  transfer: 'Taxi e trasferimenti',
  car_rental: 'Noleggio auto',
  meals: 'Ristorazione',
  parking: 'Parcheggio',
  fuel: 'Carburante',
  tolls: 'Pedaggi',
  business: 'Spesa di lavoro',
  other: 'Altro',
};

export function isTravelExpenseCategory(value: unknown): value is TravelExpenseCategory {
  return typeof value === 'string' && (TRAVEL_EXPENSE_CATEGORIES as readonly string[]).includes(value);
}

export function normalizeTravelExpenseCategory(value: unknown): TravelExpenseCategory {
  return isTravelExpenseCategory(value) ? value : 'other';
}

export function isValidTravelInterval(startValue: Date | string, endValue: Date | string): boolean {
  const start = new Date(startValue);
  const end = new Date(endValue);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || end <= start) return false;
  const earliest = Date.UTC(1900, 0, 1);
  const latest = Date.UTC(2101, 0, 1);
  return start.getTime() >= earliest && end.getTime() < latest;
}

export function canCreateTravelWalletFromEvent(meeting: {
  meetingType?: unknown;
  inviteSource?: unknown;
}): boolean {
  const meetingType = typeof meeting.meetingType === 'string' ? meeting.meetingType.trim().toLowerCase() : '';
  return (meetingType === 'evento' || meetingType === 'event') && meeting.inviteSource !== 'travel_email';
}

/** Prima bozza modificabile di un appuntamento contenuto nell'Evento. */
export function travelEventAppointmentWindow(meeting: {
  startTime?: Date | string | null;
  endTime?: Date | string | null;
}): { startTime: Date; endTime: Date } | null {
  const eventStart = new Date(meeting.startTime ?? '');
  const eventEnd = new Date(meeting.endTime ?? '');
  if (!Number.isFinite(eventStart.getTime()) || !Number.isFinite(eventEnd.getTime()) || eventEnd <= eventStart) return null;
  const startTime = new Date(eventStart);
  // Un Evento tutto il giorno non genera un appuntamento a mezzanotte.
  if (startTime.getHours() === 0 && startTime.getMinutes() === 0) startTime.setHours(9, 0, 0, 0);
  const endTime = new Date(Math.min(startTime.getTime() + 60 * 60_000, eventEnd.getTime()));
  return endTime > startTime ? { startTime, endTime } : null;
}
